import { reportError } from 'utils/error'
import { ourUuid } from 'utils'

const SESSION_IDENTIFIER_KEY = 'uniqueSessionIdentifier'

/**
 * Sets data to session storage
 *
 * @param {string} key Session storage key
 * @param {Object} data Data object to be stored in session storage
 * @param {boolean} [overwrite=false] True to overwrite existing data, if key exists. Otherwise defaults to safely append new data values only.
 */
export const setSessionStorage = (key: string, data: { [key: string]: any }, overwrite: boolean = false) => {
  try {
    const item = sessionStorage.getItem(key)
    const value = JSON.stringify(!!item && !overwrite ? { ...JSON.parse(item), ...data } : data)
    sessionStorage.setItem(key, value)
  } catch (e) {
    reportError(new Error('setLocalSession error'), { severity: 'info', metaData: e as Error })
  }
}

export const getUniqueIdentifier = (): string => {
  const item = sessionStorage.getItem(SESSION_IDENTIFIER_KEY)

  if (!!item) return item

  const identifier = ourUuid()
  sessionStorage.setItem(SESSION_IDENTIFIER_KEY, identifier)
  return identifier
}
